import AppTranslation from "../service/app_translation/AppTranslation";

export const chatsARFMessageTypes: Array<string> = [
  "20",
  "30",
  "31",
  "32",
  "33",
  "40",
  "41",
  "42",
  "43",
];

export const departmentFormType: Record<string, string> = {
  "1": AppTranslation.text("feedback"),
  "2": AppTranslation.text("appointment"),
  "3": AppTranslation.text("reservation"),
};
